import classNames from 'classnames';
import { observer } from 'mobx-react';
import moment from 'moment';
import React from 'react';
import { defaultDate } from '../../constants/cashback';
import { cashbackStore } from '../../store/cashbackStore';
import { localeStore } from 'src/mobx/localesStore';
import { IWeekModalSaveParams } from 'src/mobx/modalStore/types';
import WeekModalOpen from 'src/view/containers/Modals/WeekModal/components/WeekModalOpen/WeekModalOpen';
import { TOOLTIP_POSITION } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import Text, { TEXT } from '~/view/components/Text/Text';
import { TimePickerMode } from '~/constants/dateTime';

@observer
export default class CashbackValidity extends React.Component<{}, {}> {
  changeDate = (data: IWeekModalSaveParams) => {
    cashbackStore.changeCashback({
      start_time: data.startTime ? data.startTime : cashbackStore.cashback.start_time,
      end_time: data.endTime ? data.endTime : cashbackStore.cashback.end_time,
      all_day: data.allDay,
      end_day: data.endDate,
      start_day: data.startDate,
      days_of_week: data.daysOfWeek,
    });

    if (data.startDate && data.endDate && cashbackStore.validationErrors.date) {
      cashbackStore.validateDate();
    }
  };

  isSameTime = (time1: Date | string | undefined | null, time2: Date | string | undefined | null): boolean => {
    const formatTime = (time: Date | string | null | undefined): string => {
      return moment(time, 'HH:mm:ss').format('HH:mm:ss');
    };

    return formatTime(time1) === formatTime(time2);
  };

  get isAllDay(): boolean {
    const { start_time, end_time, all_day } = cashbackStore.cashback;
    if (all_day) return true;
    if (!start_time || !end_time) return false;

    return this.isSameTime(defaultDate.start, start_time) && this.isSameTime(defaultDate.end, end_time);
  }

  render() {
    return (
      <div className="d-flex flex-column mt-5">
        <Text
          text={localeStore.t('validity')}
          type={TEXT.BLOCK_HEADER}
          tooltip={{ message: 'cashback_validity_interval_setting_hint', position: TOOLTIP_POSITION.PORTAL }}
          required
        />
        <div className="d-flex flex-row mt-2">
          <WeekModalOpen
            startDate={cashbackStore.cashback.start_day}
            endDate={cashbackStore.cashback.end_day}
            startTime={cashbackStore.cashback.start_time}
            endTime={cashbackStore.cashback.end_time}
            allDay={this.isAllDay}
            daysOfWeek={cashbackStore.cashback.days_of_week}
            onSave={this.changeDate}
            className={classNames('full-width', { 'input-error': !!cashbackStore.validationErrors.date })}
            timePickerMode={TimePickerMode.GENERAL}
            minimumOneDayInWeek
          />
        </div>
      </div>
    );
  }
}
